import { RiMenuAddFill } from "react-icons/ri";
import { IconBaseProps } from "react-icons";

interface SelectAllIconProps extends IconBaseProps {
  className?: string;
}

export default function SelectAllIcon({ className = "", size = 24, ...props }: SelectAllIconProps) {
  return <RiMenuAddFill className={className} size={size} {...props} />;
}
